import React from 'react'

import { ArrowRight, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, shape, string } from 'prop-types'

import useTracker from 'Pods/Shared/Hooks/useTracker'
import i18n from 'Pods/Shared/I18nHome'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import CollectionCard from './Components/CollectionCard'

function CuratedCollectionsSection({ sections = EMPTY_ARRAY, locale = 'en' }) {
  const { trackEvent } = useTracker()

  const handleViewAllClick = (section) => {
    trackEvent('curated_collection_view_all_click', {
      section_name: section.title,
      section_id: section.id,
      element_url: section.viewAllHref,
    })
  }

  if (!sections || sections.length === 0) {
    return null
  }

  return (
    <div className="collection-hub-sections">
      {sections.map((section) => {
        const sectionClassName = section.id === 'print'
          ? 'collection-hub-hero collection-hub-hero--print'
          : 'collection-hub-hero'

        return (
          <section key={section.id} className={sectionClassName}>
            <div className="collection-hub-hero__container">
              <header className="collection-hub-hero__header">
                <div className="collection-hub-hero__header-text">
                  <h2 className="collection-hub-hero__title cgt-heading-300">{section.title}</h2>
                  {section.subtitle && (
                    <p className="collection-hub-hero__subtitle cgt-body-md">{section.subtitle}</p>
                  )}
                </div>
                {section.viewAllHref && (
                  <a
                    href={section.viewAllHref}
                    className="collection-hub-hero__header-action collection-hub-hero__view-all-link"
                    onClick={() => handleViewAllClick(section)}
                  >
                    <span>{i18n.t('curatedCollections.viewAllCollections', { ns: 'new-home', lng: locale })}</span>
                    <Icon svgComponent={ArrowRight} size="small" color="dark" />
                  </a>
                )}
              </header>

              <div className="collection-hub-hero__cards">
                {(section.highlightedCollections || []).map((collection) => (
                  <CollectionCard
                    key={collection.id}
                    collection={collection}
                    locale={locale}
                    sectionId={section.id}
                    sectionTitle={section.title}
                  />
                ))}
              </div>

              {section.viewAllHref && (
                <div className="collection-hub-hero__view-all">
                  <a
                    href={section.viewAllHref}
                    className="collection-hub-hero__view-all-link"
                    onClick={() => handleViewAllClick(section)}
                  >
                    <span>{i18n.t('curatedCollections.viewAllCollections', { ns: 'new-home', lng: locale })}</span>
                    <Icon svgComponent={ArrowRight} size="small" color="dark" />
                  </a>
                </div>
              )}
            </div>
          </section>
        )
      })}
    </div>
  )
}

CuratedCollectionsSection.propTypes = {
  locale: string,
  sections: arrayOf(
    shape({
      id: string,
      title: string,
      subtitle: string,
      viewAllHref: string,
      highlightedCollections: arrayOf(
        shape({
          id: string,
          title: string,
          description: string,
          imageUrl: string,
          href: string,
          previewImages: arrayOf(
            shape({
              id: string.isRequired,
              url: string.isRequired,
              alt: string.isRequired,
            })
          ),
        })
      ),
    })
  ),
}

export default CuratedCollectionsSection
